// handle click anywhere

document.querySelectorAll('[data-click-anywhere-controller]').forEach((el) => {
  const linkEl = el.querySelector('[data-click-anywhere-link]');
  el.addEventListener('click', (e) => {
    const tooltipEl = document.querySelector('[data-tooltip-content].opened');
    if (tooltipEl) {
      return;
    }
    e.stopPropagation();
    if (linkEl !== e.target && !linkEl.contains(e.target)) {
      if (e.target.nodeName === 'A') {
        return;
      }
      window.open(linkEl.href, '_blank');
    }
  });
});
